import { render } from "./Selected.vue?vue&type=template&id=6b6b84aa&scoped=true"
const script = {}

import "./Selected.vue?vue&type=style&index=0&id=6b6b84aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6b84aa"]])

export default __exports__